import http from 'plugins/axios';

export default {
    addBkkDestroyRecord(data) {
        return http.post({
            url: '/admin/add/destroy/record',
            data,
            dataType: 'form'
        });
    },

    deleteBkkDestroyRecord(data) {
        return http.post({
            url: '/admin/delete/destroy/record',
            data,
            dataType: 'form'
        });
    },

    getBkkDestroyRecordList() {
        return http.get({
            url: '/admin/destroy/record/list',
        })
    }
};
